import { apiRequest } from '@/calls/helpers';

const switchLanguage = async (data) => apiRequest('routes/switch_language', {
  method: 'POST',
  body: data,
});

export {
  // eslint-disable-next-line
  switchLanguage
};
